import React from 'react';

interface ProgressBarItem {
  key: string;
  title: string;
  description: string;
}

interface ProgressBarsProps {
  items: ProgressBarItem[];
  activeItemKey: string;
  onItemClick: (key: string) => void;
}

const ProgressBars: React.FC<ProgressBarsProps> = ({
  items,
  activeItemKey,
  onItemClick,
}) => {
  return (
    <div className="grid gap-10 md:border-b-0 border-b rounded-md">
      <div className="md:border-b md:border-gray-200">
        <nav className="mx-auto" aria-label="Progress">
          <ol
            role="list"
            className="overflow-hidden rounded-md md:flex md:rounded-none md:border-gray-200"
          >
            {items.map((item, index) => (
              <li
                key={item.key}
                onClick={() => onItemClick(item.key)}
                className={`relative overflow-hidden md:flex-1 ${index - 1 < items.findIndex((i) => i.key === activeItemKey) && 'bg-gray-50'}`}
              >
                <div className="overflow-hidden rounded-t-md border border-b-0 border-gray-200 md:border-0">
                  <a href="#" className="group">
                    <span
                      className={`${index - 1 >= items.findIndex((i) => i.key === activeItemKey) && 'group-hover:bg-gray-200'} absolute left-0 top-0 h-full w-1 bg-transparent md:bottom-0 md:top-auto md:h-1 md:w-full`}
                      aria-hidden="true"
                    ></span>

                    <span
                      className={`flex items-start px-6 py-5  text-sm font-medium ${activeItemKey !== item.key && 'px-3 py-3 sm:px-6 sm:py-5'}`}
                    >
                      <span className="shrink-0 relative">
                        <span
                          className={`flex size-10 items-center  ${activeItemKey !== item.key && 'sm:w-9 sm:h-9 w-6 h-6'}  justify-center rounded-full  ${index - 1 < items.findIndex((i) => i.key === activeItemKey) ? 'bg-gray-500 text-white' : 'bg-gray-200'} ${activeItemKey === item.key && '!bg-[#EA8A31] text-xl'}`}
                        >
                          {activeItemKey === item.key && (
                            <div className="bg-[#EA8A31] hidden sm:inline-block absolute bg-opacity-25 w-full h-full -z-[0] animate-ping rounded-full">
                              {' '}
                            </div>
                          )}

                          <div className={`absolute z-10`}>
                            {activeItemKey === item.key ? (
                              <div>
                                {activeItemKey === 'capture' && <div>⛳</div>}
                                {activeItemKey === 'set' && <div>📋</div>}
                                {activeItemKey === 'preview' && <div>👀</div>}
                                {activeItemKey === 'report' && <div>📤</div>}
                              </div>
                            ) : (
                              <span className="text-md">{index + 1}</span>
                            )}
                          </div>
                        </span>
                      </span>
                      <span className="ml-4 mt-0.5 leading-6 flex min-w-0 flex-col">
                        <span className="text-sm font-medium">
                          {item.title}
                        </span>
                        <span
                          className={`text-xs text-gray-500 ${activeItemKey !== item.key && 'hidden sm:inline-block'}`}
                        >
                          {item.description}
                        </span>
                      </span>
                    </span>
                  </a>
                </div>

                {index !== 0 && (
                  <div
                    className="absolute inset-0 left-0 top-0 hidden w-3 md:block"
                    aria-hidden="true"
                  >
                    <svg
                      className={`size-full ${index - 1 > items.findIndex((i) => i.key === activeItemKey) ? 'text-gray-100' : 'text-gray-300'}`}
                      viewBox="0 0 12 82"
                      fill="none"
                      preserveAspectRatio="none"
                    >
                      <path
                        d="M0.5 0V31L10.5 41L0.5 51V82"
                        stroke="currentcolor"
                        vectorEffect="non-scaling-stroke"
                      />
                    </svg>
                  </div>
                )}
              </li>
            ))}
          </ol>
        </nav>
      </div>
    </div>
  );
};

export default ProgressBars;
